import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface LanguageState {
    language: string;
}

export const defaultLanguageState: LanguageState = {
    language: 'en'
};

const initialState: LanguageState = defaultLanguageState;

export const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setLanguage: (state, action: PayloadAction<string>) => {
            state.language = action.payload;
        }
    }
});

export const { setLanguage } = languageSlice.actions;
export const selectLanguage = (state: RootState) => state.language.language;

export default languageSlice.reducer;
